module.exports = __webpack_public_path__ + "img/ifactory.5ede2d6c.jpg";